import React from 'react';
import TextField from 'material-ui/TextField'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import DatePicker from 'material-ui/DatePicker';
import FileSelector from './fileselector'

export const renderText = ({input, label, ...custom, meta: {touched, error, warning}}) => {
    return (
        <div>
            <MuiThemeProvider>
                <TextField
                    hintText={label}
                    floatingLabelText={label}
                    errorText={touched && error}
                    multiLine={true}
                    fullWidth={true}
                    {...input}
                    />
            </MuiThemeProvider>
        </div>
    );
};

export const renderTextArea = ({input, label, ...custom, meta: {touched, error, warning}}) => {
    return (
        <div>
            <MuiThemeProvider>
                <TextField
                    hintText={label}
                    floatingLabelText={label}
                    errorText={touched && error}
                    multiLine={true}
                    rows={2}
                    rowsMax={100}
                    fullWidth={true}
                    {...input}
                    />
            </MuiThemeProvider>
        </div>
    );
};

export const renderDatePicker = ({input, label, ...custom, meta: {touched, error, warning}}) => {
    let DateTimeFormat = global.Intl.DateTimeFormat;
    return (
        <div>
            <div className="spacer-md"></div>
            <div className="spacer-sm"></div>
            <MuiThemeProvider>
                <DatePicker
                    hintText={label}
                    fullWidth={true}
                    formatDate={new DateTimeFormat('en-US', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                      }).format}
                    value={input.value ? input.value : input}
                    onChange={(event,date) => input.onChange(date)}
                />
            </MuiThemeProvider>
        </div>
    );
};

export const renderSelect = ({input, label, type, options, ...custom, meta: {touched, error, warning}}) => {
    return (
        <div>
            <MuiThemeProvider>
            <SelectField
                floatingLabelText={label}
                errorText={touched && error}
                {...input}
                onChange={(event, index, value) => input.onChange(value)}
                children={renderSelectOptions(options)}
                fullWidth={true}
                {...custom}
                />
            </MuiThemeProvider>
        </div>
    );
};

export const renderDBSelect = ({input, label, type, ...custom, meta: {touched, error, warning}}, options) => {
    return (
        <div>
            <MuiThemeProvider>
            <SelectField
                floatingLabelText={label}
                errorText={touched && error}
                {...input}
                onChange={(event, index, value) => input.onChange(value)}
                children={renderSelectOptions(options)}
                fullWidth={true}
                {...custom}
                />
            </MuiThemeProvider>
        </div>
    );
};


export const renderMultiSelect = ({input, label, type, options, meta: {touched, error, warning}}) => {
    return (
        <div>
            <MuiThemeProvider>
            <SelectField
                floatingLabelText={label}
                errorText={touched && error}
                {...input}
                onChange={(event, index, value) => input.onChange(value)}
                children={renderMultiSelectOptions(options,input.value)}
                fullWidth={true}
                multiple={true}
                />
            </MuiThemeProvider>
        </div>
    );
};

const renderSelectOptions = (options) => {
    if (options) {
        return (options.map((option) =>
            <MenuItem key={option.value} value={option.value} primaryText={option.text} />
        ));
    } else {
        return [];
    }
}

const renderMultiSelectOptions = (options,values) => {
    return (options.map((option) =>
        <MenuItem
            key={option.value}
            value={option.value}
            insetChildren={true}
            checked={values.indexOf(option.value) > -1}
            primaryText={option.text}
        />
    ));
}

export const renderUpload = ({label}, id) => {
    return (
        <FileSelector id={id} label={label}/>
   );
}



// WEBPACK FOOTER //
// ./src/components/formcomponents.js